@if (loading) {
    <app-loader></app-loader>
}

<div class="evida-shared-card">
    <div [ngClass]="{ 'mb-medium': title }">
        @if (title) {
            <h2 class="header-medium mb-large" [translate]="title | translate"></h2>
        }
        @if (subTitle) {
            <h4 class="sub-title" [ngClass]="headerClass" [innerHTML]="subTitle | translate"></h4>
        }
        @if (byline) {
            <h4 class="byline" [translate]="byline | translate"></h4>
        }
    </div>

    @if (message) {
        <app-info-message class="flex mb-medium" [hint]="message"></app-info-message>
    }

    <mat-card
        appearance="outlined"
        class="mat-elevation-z1 evida-shared-card-material"
        [ngClass]="{ 'hide-background': hideBackground }"
    >
        @if (header || body) {
            <div class="mb-30px">
                @if (header) {
                    <h3 class="mb-medium" [translate]="header | translate"></h3>
                }
                @if (body) {
                    <span class="sm:body-small body-copy" [innerHTML]="body | translate"></span>
                }
            </div>
        }

        <mat-card-content class="w-full mx-auto">
            <ng-content></ng-content>
        </mat-card-content>
    </mat-card>
</div>
